import { BoxedRow, IconInvoicePlanFileRegular, skinVars } from '@telefonica/mistica';
import { t } from 'i18next';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { showSnackbar } from '../../../../utils/store/features/user';
import { useDispatch } from 'react-redux';
import useUserlight from '../../../../utils/hooks/useUserLight';

const BillsDownloadCard = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isLight = useUserlight();

    const navigationHandler = () => {
        if (isLight) dispatch(showSnackbar());
        else navigate('/bills-download');
    };

    return (
        <div className='bills-download-button'>
            <BoxedRow
                onPress={navigationHandler}
                asset={
                    <div className='bills-download-button__icon' style={{ backgroundColor: skinVars.colors.brandLow }}>
                        <IconInvoicePlanFileRegular color={skinVars.colors.brand} size={24} />
                    </div>
                }
                title={t('downloadInvoices')}
            />
        </div>
    );
};

export default BillsDownloadCard;
